import { Component, inject } from '@angular/core';
import { ColmecPartnerAgreement } from '../../services/colmec-partner-agreements.service';
import { ListItemRendererComponent } from 'gung-list';
import { ColmecPartnerAgreementsActionConfigService } from '../../services/colmec-partner-agreements-action-config.service';

@Component({
    selector: 'colmec-partner-agreements-list-view',
    templateUrl: './colmec-partner-agreements-list-view.component.html',
    styleUrls: ['./colmec-partner-agreements-list-view.component.scss'],
    standalone: false
})
export class ColmecPartnerAgreementsListViewComponent extends ListItemRendererComponent<ColmecPartnerAgreement[]> {
  protected actionConfig = inject(ColmecPartnerAgreementsActionConfigService);
}
